import { render, staticRenderFns } from "./AppReviewFeedback.vue?vue&type=template&id=6e9ae21a&scoped=true"
import script from "./AppReviewFeedback.vue?vue&type=script&lang=js"
export * from "./AppReviewFeedback.vue?vue&type=script&lang=js"
import style0 from "./AppReviewFeedback.vue?vue&type=style&index=0&id=6e9ae21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ae21a",
  null
  
)

export default component.exports